export const SERVICE_DIGITAL_CHECKOUT_FLOW = 'service_digital';

export const SERVICE_ANALYTICS_EVENT = {
  OFFER_VIEWED: 'service.offer.viewed',
  CTA_CLICKED: 'service.offer.cta_clicked',
  CHECKOUT_STARTED: 'service.checkout.started',
  CHECKOUT_PAID: 'service.checkout.paid',
  PRIORITY_DM_SUBMITTED: 'priority_dm.submitted',
  PRIORITY_DM_FULFILLED: 'priority_dm.fulfilled',
  WEBINAR_REGISTERED: 'webinar.registered',
  COHORT_ENROLLED: 'cohort.enrolled',
  PACKAGE_PURCHASED: 'package.purchased',
  OFFER_REFUNDED: 'service.offer.refunded',
} as const;

export type ServiceAnalyticsEventName =
  (typeof SERVICE_ANALYTICS_EVENT)[keyof typeof SERVICE_ANALYTICS_EVENT];

export type ServiceOfferTypeValue =
  | 'digital'
  | 'one_to_one'
  | 'priority_dm'
  | 'webinar'
  | 'cohort'
  | 'package';

export type ServiceOfferStatusValue = 'draft' | 'published' | 'archived';

export type ServiceOfferVisibilityValue = 'public' | 'unlisted' | 'hidden';

export function slugifyServiceOfferTitle(title: string): string {
  const base = title
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
  return base || 'offer';
}

export function validateDigitalOfferPublish(input: {
  title: string;
  priceCents: number;
  refundPolicyText?: string | null;
  fileKey?: string | null;
  externalUrl?: string | null;
}): string[] {
  const errors: string[] = [];
  if (!input.title.trim()) errors.push('Title is required');
  if (input.priceCents > 0 && !input.refundPolicyText?.trim()) {
    errors.push('Refund policy is required for paid offers');
  }
  if (!input.fileKey?.trim() && !input.externalUrl?.trim()) {
    errors.push('Add a file or external link before publishing');
  }
  return errors;
}

export function computeServicePlatformFeeCents(amountCents: number, platformFeePercent: number): number {
  if (amountCents <= 0) return 0;
  return Math.round((amountCents * platformFeePercent) / 100);
}
